// Copyright (c) 2016 Deere & Company

import './main-menu.scss';
import React, {PropTypes} from 'react';
import AppConfig from '../shared/models/app-config';
import {IndexLink} from 'react-router';
import SapEnvironments from './sap-environments';
import SecureLink from '../shared/components/secure-link';

const MainMenu = props =>
    <nav className='main-menu'>
        <IndexLink
            activeClassName='selected'
            className='home'
            to={'/'}
        >
            <span className='icon-home'/>
        </IndexLink>
        <SecureLink
            activeClassName='selected'
            className='products'
            label='PRODUCT_TRACKING'
            securityModule={'PRT'}
            to={'/products'}
        />
        {props.isSapUp &&
        <SecureLink
            activeClassName='selected'
            className='claims'
            label={'CLAIMS'}
            securityModule={'CLAIM'}
            to={'/claims'}
        />
        }
        <SecureLink
            activeClassName='selected'
            className='pips'
            label={'PIPS'}
            securityModule={'PIP'}
            to={'/pips'}
        />
        <SecureLink
            activeClassName='selected'
            className='part-requests'
            label={'PART_REQUESTS'}
            securityModule={'PART_RETURNS_EDIT'}
            to={'/part-requests'}
        />
        <SecureLink
            activeClassName='selected'
            className='tcsm'
            label={'TCSM'}
            securityModule={'TCSM'}
            to={'/tcsm'}
        />
        <SecureLink
            activeClassName='selected'
            className='tabm'
            label={'TABM'}
            securityModule={'TABM'}
            to={'/tabm'}
        />
        <SecureLink
            activeClassName='selected'
            className='rga'
            label={'Part Request Analysis'}
            securityModule={'RECALLED_PARTS'}
            to={'/rga'}
        />
        {props.appConfig.sapEnvironments.length > 1 && props.isSapUp &&
            <SapEnvironments
                onSapEnvironmentChange={props.onSapEnvironmentChange}
                sapEnvironments={props.appConfig.sapEnvironments}
            />
        }
    </nav>;

MainMenu.displayName = 'MainMenu';
MainMenu.propTypes = {
    appConfig: PropTypes.instanceOf(AppConfig).isRequired,
    isSapUp: PropTypes.bool.isRequired,
    onSapEnvironmentChange: PropTypes.func.isRequired
};

export default MainMenu;



// WEBPACK FOOTER //
// ./src/app/main-menu.js